module.exports = __webpack_public_path__ + "static/img/managaer-qrcode-1.5e3cbde5.png";